import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Scale } from "lucide-react";
import legalContent from "../data/content/mentions-legales.json";

const MentionsLegalesPage = () => {
  const sections = Array.isArray(legalContent?.sections)
    ? legalContent.sections.filter((section) => section && typeof section === "object")
    : [];

  return (
    <div className="pt-24 pb-16 min-h-screen bg-[#F6F7F1]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-16 bg-[#D4AF37]" />
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <div className="h-px w-16 bg-[#D4AF37]" />
          </div>
          <h1 className="font-playfair text-4xl md:text-5xl font-bold text-gray-900 mb-4 text-center">
          {typeof legalContent?.title === "string" ? legalContent.title : "Mentions légales"}
          </h1>
          <div className="flex justify-center mb-12">
            <Scale className="w-8 h-8 text-[#E5007D]" />
          </div>

          <div className="space-y-10">
            {sections.map((section, index) => (
              <section
                key={section.title}
                className={index % 2 === 0 ? "bg-[#FFF5F8] rounded-2xl p-8" : ""}
              >
                <h2 className="font-playfair text-2xl font-bold text-gray-900 mb-4">
                  {section.title}
                </h2>
                <div className="text-gray-600 leading-relaxed space-y-2 text-sm">
                  {(Array.isArray(section.entries) ? section.entries : [])
                    .filter((entry) => entry && typeof entry === "object")
                    .map((entry, entryIndex) => (
                    <p key={`${section.title}-entry-${entryIndex}`}>
                      {typeof entry.value === "string" && entry.value ? (
                        <>
                          {typeof entry.label === "string" && <strong>{entry.label} :</strong>} {entry.value}
                        </>
                      ) : (
                        typeof entry.label === "string" ? entry.label : ""
                      )}
                    </p>
                  ))}
                  {(Array.isArray(section.paragraphs) ? section.paragraphs : [])
                    .filter((paragraph) => typeof paragraph === "string" && paragraph.length > 0)
                    .map((paragraph, paragraphIndex) => (
                    <p key={`${section.title}-${paragraphIndex}`}>{paragraph}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
